import { compose, withHandlers, withProps } from 'recompose'
import { connect } from 'react-redux'
import { QUOTE_SUMMARY_PAGE } from 'constant'
import { formatPhoneNumber } from 'helpers/phone-number'
import withSelectedLocation from 'components/common/hoc/withSelectedLocation'
import { showStoreLocatorModal } from 'actions/storeLocator'
import { navigateToQuote } from 'components/AddToQuoteModal/ActionLinks/actions'
import { getHasActiveVehicleStatus } from 'selectors'
import { getCurrentStorePhoneNumber } from 'selectors/getCurrentStore'
import Tire from './Tire'

const mapStateToProps = (state, { selectedLocation }) => ({
  showSelectLocationLinkInsteadOfPrice: !selectedLocation,
  storePhoneNumber: getCurrentStorePhoneNumber(state),
  formattedStorePhoneNumber: formatPhoneNumber(getCurrentStorePhoneNumber(state)),
  hasActiveVehicle: getHasActiveVehicleStatus(state)
})

const withNavigation = withHandlers({
  navigateToQuoteHandler: ({ navigateToQuote }) => () =>
    navigateToQuote(QUOTE_SUMMARY_PAGE)
})

const withInfo = withProps(({
  listPrice,
  hasMapPrice,
  seePriceIncartMessage,
  seePriceTitle
}) => ({
  isShowPrice: Boolean(listPrice && !hasMapPrice),
  seePriceTitle: hasMapPrice ? seePriceIncartMessage : seePriceTitle
}))

export default compose(
  withSelectedLocation,
  connect(mapStateToProps, { showStoreLocatorModal, navigateToQuote }),
  withNavigation,
  withInfo
)(Tire)
